export default "__VITE_ASSET__DyTRhjIh__"